//GLOBAL
export const SHOW_ALERT					= 'show_alert'
export const HIDE_ALERT					= 'hide_alert'
export const SHOW_CONFIRM				= 'show_confirm'
export const HIDE_CONFIRM				= 'hide_confirm'
export const SHOW_NETWORK_ACTIVITY		= 'show_network_activity'
export const HIDE_NETWORK_ACTIVITY		= 'hide_network_activity'

//
// Global Stores
//
//Auth
export const AuthKeys = {
	//Inputs
	SIGN_IN_EMAIL_CHANGED				: 'auth__sign_in_email_changed',
	SIGN_IN_PASSWORD_CHANGED			: 'auth__sign_in_password_changed',

	FORGOT_EMAIL_CHANGED 				: 'auth__forgot_email_changed',

	RESET_PASSWORD_CHANGED 				: 'auth__reset_password_changed',

	//Requests
	SIGN_IN_USER_SUCCESS 				: 'auth__sign_in_user_success',
	SIGN_IN_USER_FAIL 					: 'auth__sign_in_user_fail',

	SIGN_OUT_USER_SUCCESS				: 'auth__sign_out_user_success',

	RESET_PASSWORD_SUCCESS 				: 'auth__reset_password_success',
	RESET_PASSWORD_FAIL 				: 'auth__reset_password_fail',

	SEND_FORGOT_PASSWORD_EMAIL_SUCCESS	: 'auth__send_forgot_password_email_success',
	SEND_FORGOT_PASSWORD_EMAIL_FAIL		: 'auth__send_forgot_password_email_fail',

	FETCH_USER_PERMISSIONS				: 'auth__load_user_permissions',
	SAVE_USER_PERMISSIONS_WATCHER		: 'auth__save_user_permissions_watcher',
	REMOVE_USER_PERMISSIONS_WATCHER		: 'auth__remove_user_permissions_watcher',
};

//Loading
export const LoadingKeys = {
	USER_CHECK_STARTED		: 'loading__user_check_started',
	USER_CHECK_COMPLETE 	: 'loading__user_check_complete',
};

//HOME
export const HomeKeys = {
	FETCH_MEDIUM_FEED 			: 'home__fetch_medium_feed',
	FETCH_INSTAGRAM_FEED 		: 'home__fetch_instagram_feed',

	CONTACT_NAME_CHANGED 		: 'home__contact_name_changed',
	CONTACT_EMAIL_CHANGED 		: 'home__contact_email_changed',
	CONTACT_SUBJECT_CHANGED 	: 'home__contact_subject_changed',
	CONTACT_MESSAGE_CHANGED 	: 'home__contact_message_changed',

	SEND_CONTACT_EMAIl_SUCCESS 	: 'home__send_contact_email_success',
	SEND_CONTACT_EMAIl_FAIL 	: 'home__send_contact_email_fail',
}

//
//Player
//
export const PlayerKeys = {}

//
//Admin
//
export const AdminKeys = {}



// WEBPACK FOOTER //
// ./src/actions/types.js